export default __webpack_public_path__ + "static/media/silver-coin.b9557aaa.webp";